import { createTheme } from '@mantine/core';

// Colors:
//   • Navy: #09223c
//   • Orange: #ed5233
//   • Black: #000000
//   • White (background): #ffffff
// Fonts:
//   • Serif: Lora
//   • Sans Serif: Open Sans

export const theme = createTheme({
  fontFamily: 'Lora, sans-serif',
  colors: {
    'btb-orange': [
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
      '#ed5233',
    ],
    'btb-navy': [
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
      '#09223c',
    ],
  },
  primaryColor: 'btb-orange',
});
